export default "__VITE_ASSET__wLVa5zLF__"